const setModal = () => {
  const triggers = document.querySelectorAll('.js-modal-trigger');
  const body = document.querySelector('body');

  for(const trigger of triggers) {
    const contentsId = trigger.getAttribute('modal-content');
    const dataSrc = trigger.getAttribute('data-src');
    const target = document.getElementById(contentsId);
    const closeBtn = target.querySelector('.modal-close');
    const modalBg = target.querySelector('.modal-bg');
    const checkbox = target.querySelector('#agree');
    const btn = target.querySelector('#js-modal-btn');

    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      target.classList.add('is-open');
      body.classList.add('no-scroll');

      if(dataSrc) {
        btn.setAttribute('href', dataSrc);
      }

      if(checkbox.checked) {
        checkbox.checked = false;
        btn.classList.add('disabled')
      }

      checkbox.addEventListener('change', function() {
        if(this.checked) {
          btn.classList.remove('disabled')
        } else {
          btn.classList.add('disabled')
        }
      })
    });

    closeBtn.addEventListener('click', function() {
      target.classList.remove('is-open');
      body.classList.remove('no-scroll');

      if(dataSrc) {
        btn.setAttribute('href', '');
      }
    });

    modalBg.addEventListener('click', function() {
      target.classList.remove('is-open');
      body.classList.remove('no-scroll');

      if(dataSrc) {
        btn.setAttribute('href', '');
      }
    });
  }
}

export default setModal